import React, { useState } from 'react'
import { PortfolioHolder } from './style'
import PortfolioTile from './PortfolioTile'
import FeedbackForm from '../../components/form/FeedbackForm'
import PreviewPane from './previewPane'
function Portfolio() {
    const [showPane, setShowPane] = useState(false)
    const [link, setLink] = useState("")

    const configurePane = (paneBool, previewLinkData) => {
        setLink(previewLinkData)
        setShowPane(paneBool)
    }
    return (
        <>
            {showPane &&
                <PreviewPane pane={showPane} link={link} setPane={setShowPane} />}
            <PortfolioHolder initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5, duration: 1 }} className="flipContainer">
                <PortfolioTile openPreviewFunc={configurePane} previewLink="https://mcmakler.de" image="/images/Screenshot 2022-05-25 at 19-57-17 McMakler Ihr Immobilienmakler für den Immobilienverkauf.png" />
                <PortfolioTile openPreviewFunc={configurePane} previewLink="https://moses-py.github.io/image-gallery" image="/images/Screenshot 2022-05-25 at 19-57-06 React App.png" />
                <PortfolioTile openPreviewFunc={configurePane} previewLink="https://moses-folio.web.app" image="/images/Screenshot 2022-05-24 at 16-51-16 React App.png" />
                <PortfolioTile openPreviewFunc={configurePane} previewLink="https://moses-py.github.io/alisimbi" image="/images/Screenshot 2022-05-25 at 19-56-44 Alisimbi The future of Agribusiness.png" />
                <PortfolioTile openPreviewFunc={configurePane} previewLink="https://moses-py.github.io/krisana" image="/images/Screenshot 2022-05-25 at 19-57-00 Krisana Vigus.png" />
                <PortfolioTile openPreviewFunc={configurePane} previewLink="https://moses-py.github.io/diva" image="/images/Screenshot 2022-05-25 at 19-57-24 Sexy Divas.png" />
            </PortfolioHolder>
        </>
    )
}

export default Portfolio